import * as Sentry from '@sentry/vue'

const getLocation = async (appData) => {
  if (appData?.latitude && appData?.longitude && appData?.source) {
    return {
      latitude: appData.latitude,
      longitude: appData.longitude,
      source: appData.source
    }
  }

  const options = {
    enableHighAccuracy: true,
    timeout: 5000,
    maximumAge: 60000
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        let crd = pos.coords

        resolve({
          latitude: crd.latitude,
          longitude: crd.longitude,
          source: crd.accuracy <= 50 ? 'GPS' : 'IP',
          positioning: crd.accuracy <= 50 ? 4 : 2
        })
      },
      (err) => {
        console.log('Error getting location', err)
        resolve({})
      },
      options
    )
  })
}

const fetchLocationFromApi = async () => {
  try {
    const response = await fetch('https://free.freeipapi.com/api/json')
    const data = await response.json()

    return {
      latitude: data.latitude,
      longitude: data.longitude,
      country: data.countryName,
      source: 'IP'
    }
  } catch (error) {
    console.error(error)
    Sentry.captureException(error)
    return {
      positioning: 0,
      latitude: 0,
      longitude: 0,
      country: '',
      source: ''
    }
  }
}

export { getLocation, fetchLocationFromApi }
